import { createStyles, makeStyles } from '@hawkins/styles';
import { colors, spacings } from '@hawkins/variables';
export function verticalListItemStyles(theme) {
    var hawkins = theme.hawkins;
    return createStyles({
        /** class name of the root element. It expands to the whole width of the Vertical List container. */
        root: {
            borderBottom: hawkins.theme === 'light' ? "1px solid ".concat(colors.blackT10) : "1px solid ".concat(colors.whiteT20),
            display: 'flex',
            width: '100%',
            alignContent: 'space-around',
            justifyContent: 'space-between',
            padding: "".concat(spacings.space1, " 0"),
            flexWrap: 'wrap',
        },
        /** class name of content container. This container wraps the left section of the component: avatar/icon, label and metadata. */
        contentContainer: {
            display: 'flex',
            flexGrow: 2,
            flexShrink: 0,
            alignItems: 'center',
        },
        /** class name of the adornment container. This contains: avatar or icon. */
        adornmentContainer: {
            marginLeft: spacings.space1,
            display: 'flex',
            alignItems: 'center',
        },
        /** class name of the text container. This contains: label or label and metadata. */
        textContainer: {
            marginLeft: spacings.space2,
        },
        /** class name of the action container. This container wraps the right section of the component. */
        actionContainer: {
            display: 'flex',
            alignItems: 'center',
        },
    });
}
export var useVerticalListItemStyles = makeStyles(verticalListItemStyles, {
    name: 'Hawkins-VerticalListItem',
});
